import { urlForImage } from '@/sanity/lib/utils';
import type { CSSProperties } from 'react';

interface SectionBackground {
  backgroundType?: string;
  gradient?: string;
  color?: { value?: string } | null;
  imageReference?: unknown;
}

export function getSectionBackgroundStyle(
  background?: SectionBackground | null
): CSSProperties {
  if (!background) return {};

  switch (background.backgroundType) {
    case 'gradient':
      return background.gradient ? { background: background.gradient } : {};
    case 'color':
      return background.color?.value
        ? { backgroundColor: background.color.value }
        : {};
    case 'image': {
      const imageUrl = background.imageReference
        ? (urlForImage(background.imageReference)?.url() as string)
        : undefined;
      return imageUrl ? { backgroundImage: `url(${imageUrl})` } : {};
    }
    default:
      return {};
  }
}
